import React, { useState, useEffect } from "react";
import { Container, Typography, Box, Grid, Link } from "@mui/material";
import { postNotification } from "../../components/utilities/Notifications";
import ListResponsive from "../../components/other/ListResponsive";
import { BCPSquarePlus } from "../../components/icons/bcp/BCPIcons";
import { getData } from "../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function TagList() {
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState([]);

  const screenWidth = window.innerWidth;

  useEffect(() => {
    const go = async () => {
      try {
        const tagData = await getData(`/pages/tags/`, {
          queryStringParameters: {
            env: getEnvironmentVariable("COMPANY_FLAG"),
          },
        });

        const newTags = tagData.data;

        newTags.sort((a, b) => {
          let titleA = a.title.toLowerCase();
          let titleB = b.title.toLowerCase();
          if (titleA > titleB) return 1;
          if (titleA < titleB) return -1;
          return 0;
        });

        setTags(newTags);
        setLoading(false);
      } catch (err) {
        postNotification("error", err);
        setLoading(false);
      }
    };

    go();
  }, []);

  const ListRow = (props) => {
    const { heading, row } = props;

    return (
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={1}
        sx={{
          p: 1,
          fontSize: "14px",
          overflow: "hidden",
          textAlign: "center",
          borderBottom: heading ? "" : "1px solid",
          borderImage: heading
            ? ""
            : screenWidth > 600
            ? "linear-gradient(to right, rgba(0,0,0,0) 1%, black 1%, black 99%, rgba(0,0,0,0) 99%) 1;"
            : "linear-gradient(to right, rgba(0,0,0,0) 3%, black 3%, black 99%, rgba(0,0,0,0) 99%) 1;",
        }}
      >
        <Grid item xs sx={{ maxWidth: ["125px", "unset"], overflow: "hidden" }}>
          {heading ? "Title" : row.title}
        </Grid>

        <Grid item xs sx={{ maxWidth: ["125px", "unset"], overflow: "hidden" }}>
          {heading ? "Permalink" : row.permalink}
        </Grid>

        <Grid item xs sx={{ maxWidth: ["60px", "150px"], overflow: "hidden" }}>
          {heading ? "Sort Order" : row.sortOrder}
        </Grid>

        <Grid item xs sx={{ maxWidth: ["60px", "150px"], overflow: "hidden" }}>
          {heading ? "Primary Tag" : row.isPrimaryTag ? "Yes" : "No"}
        </Grid>

        <Grid item xs sx={{ maxWidth: ["60px", "150px"], overflow: "hidden" }}>
          {heading ? (
            "Edit"
          ) : (
            <Link href={`/cms/tag/${row?.id}`} underline="none">
              Edit
            </Link>
          )}
        </Grid>
      </Grid>
    );
  };

  return (
    <Box width="100%">
      <Container maxWidth="lg" sx={{ pt: 2, pb: 2 }}>
        <Grid container sx={{ gap: 2, p: 2 }}>
          <Grid
            item
            xs={12}
            md={8}
            p={{ md: 2 }}
            sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
          >
            <Typography variant="h3">Tag List</Typography>
          </Grid>

          <Grid item xs={12} p={{ md: 2 }}>
            <ListResponsive
              originalList={loading ? null : tags}
              doSearch
              doPages
              initialRowsPerPage={24}
              rowsPerPageArray={[12, 24, 48, 96, { label: "All", value: -1 }]}
              actionButton={{
                props: {
                  variant: "contained",
                  color: "primary",
                  fullWidth: true,
                  href: "/cms/new-tag",
                  startIcon: <BCPSquarePlus />,
                },
                label: "New Tag",
              }}
              searchProps={{
                label: "Search Tags",
                performSearch: (originalList, searchText) => {
                  if (!searchText || searchText === "") {
                    return originalList;
                  } else {
                    var filteredList = originalList.filter(function (el) {
                      if (el?.title?.toLowerCase().includes(searchText))
                        return true;
                      if (el?.titleSearch?.toLowerCase().includes(searchText))
                        return true;
                      if (el?.permalink?.toLowerCase().includes(searchText))
                        return true;
                      return false;
                    });
                    return filteredList;
                  }
                },
              }}
              rowProps={{
                headings: (
                  <Grid
                    item
                    xs={12}
                    sx={{
                      p: "2px",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                      borderRadius: "4px 4px 0 0",
                      backgroundColor: "table.headerBackground",
                      color: "table.headerColor",
                    }}
                  >
                    <ListRow heading />
                  </Grid>
                ),

                mapFunction: (row, index) => <ListRow row={row} key={index} />,
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
